import React from 'react';
import PropTypes from 'prop-types';

const DoordashIcon = ({ className, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 180 180"
  >
    <rect fill="none" className="icon DoordashIcon" width="180" height="180" />
    <path
      fill="#ff3008"
      className="icon DoordashIcon"
      d="M40.078,132.2v8.586H42.2a3.947,3.947,0,0,0,2.905-1.3,4.37,4.37,0,0,0,1.171-3.036,4.183,4.183,0,0,0-1.171-3.036,4,4,0,0,0-2.949-1.258l-2.082.043Zm2.125-2.689a6.982,6.982,0,1,1,0,13.964H37.476a.373.373,0,0,1-.347-.347h0v-13.27a.373.373,0,0,1,.347-.347Zm17.3,11.579a4.526,4.526,0,0,0,4.163-2.819,4.764,4.764,0,0,0-.954-5.03,4.391,4.391,0,0,0-4.9-1,4.616,4.616,0,0,0,1.691,8.846m0-11.882a7.286,7.286,0,1,1-7.372,7.285,7.3,7.3,0,0,1,7.372-7.285m17.65,11.882a4.6,4.6,0,1,0-4.467-4.6,4.744,4.744,0,0,0,1.3,3.252,4.325,4.325,0,0,0,3.166,1.344m0-11.882a7.287,7.287,0,1,1-7.416,7.285,7.3,7.3,0,0,1,7.416-7.285M94.329,132.2H91.293v3.686h3.036a2,2,0,0,0,1.3-.477,1.884,1.884,0,0,0,.043-2.645,1.739,1.739,0,0,0-1.344-.564Zm-5.941-2.342a.373.373,0,0,1,.347-.347h5.681a4.539,4.539,0,0,1,4.683,4.6,4.476,4.476,0,0,1-2.428,4.076l2.6,4.77a.325.325,0,0,1,0,.39.29.29,0,0,1-.3.173h-2.3a.365.365,0,0,1-.3-.173l-2.515-4.727H91.336v4.51a.342.342,0,0,1-.347.347H88.778a.373.373,0,0,1-.347-.347h0l-.043-13.27Zm18.344,2.428v8.586h2.125a4.072,4.072,0,0,0,2.905-1.257,4.521,4.521,0,0,0,0-6.071,4,4,0,0,0-2.949-1.258Zm2.125-2.689a6.982,6.982,0,1,1,0,13.964h-4.727a.373.373,0,0,1-.347-.347h0v-13.27a.373.373,0,0,1,.347-.347Zm15.915,3.383-1.648,4.6h3.3Zm-2.6,7.2-1.084,3.079a.378.378,0,0,1-.347.26H118.4a.338.338,0,0,1-.3-.13.327.327,0,0,1-.043-.347l5.074-13.27a.343.343,0,0,1,.347-.217h2.645a.343.343,0,0,1,.347.217l5.074,13.27a.327.327,0,0,1-.043.347c-.087.087-.173.174-.3.13h-2.342a.33.33,0,0,1-.347-.26l-1.084-3.079Zm12.056-6.9c0-2.212,1.865-4.076,4.77-4.076a6.032,6.032,0,0,1,4.25,1.648.34.34,0,0,1,0,.477h0l-1.3,1.344a.34.34,0,0,1-.477,0h0a3.377,3.377,0,0,0-2.255-.911c-1.171,0-2.038.694-2.038,1.518,0,2.6,6.9,1.084,6.9,6.115,0,2.515-1.865,4.467-5.161,4.467a6.812,6.812,0,0,1-4.944-2.038.34.34,0,0,1,0-.477h0l1.258-1.3a.34.34,0,0,1,.477,0h0a4.466,4.466,0,0,0,2.992,1.258c1.474,0,2.428-.781,2.428-1.821.043-2.689-6.9-1.171-6.9-6.2m22.377-3.426V135.1h-5.854v-5.247a.342.342,0,0,0-.347-.347h-2.168a.373.373,0,0,0-.347.347h0v13.27a.373.373,0,0,0,.347.347h2.212a.373.373,0,0,0,.347-.347V137.79h5.854v5.334a.373.373,0,0,0,.347.347H159.2a.373.373,0,0,0,.347-.347v-13.27a.342.342,0,0,0-.347-.347h-2.212A.382.382,0,0,0,156.6,129.854Z"
      transform="translate(-10.56 1.162)"
    />
    <path
      fill="#ff3008"
      className="icon DoordashIcon"
      d="M121.393,145.875c-5.24-11.44-15.719-18.547-26.947-18.374H8.965a2.988,2.988,0,0,0-2.695,2.08,3.894,3.894,0,0,0,.6,3.64l18.563,21.321a8.244,8.244,0,0,0,6.288,2.947H92.051c4.341,0,7.785,3.813,7.785,8.84,0,4.854-3.443,8.84-7.635,9.014H50.583a2.988,2.988,0,0,0-2.695,2.08,3.893,3.893,0,0,0,.6,3.64L67.05,202.557a8.245,8.245,0,0,0,6.288,2.947H92.2c24.4-.173,42.816-29.988,29.193-59.628"
      transform="translate(20.775 -91.498)"
    />
  </svg>
);

DoordashIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

DoordashIcon.defaultProps = {
  width: '50px',
  height: '50px',
};

export default DoordashIcon;
